import React from 'react';

import { useForm } from 'react-hook-form';
import { observer } from 'mobx-react';
import { Button, LbInput } from '@infoods/lifebase-ui';

import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';
import { ScanIqCustomerListFilterFormValues } from '../../../interfaces/ScanIqCustomerListFilters';
import { useAutoSubmitForm } from '../../../../shared/hooks/useAutoSubmitForm';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { SetupStatusTab } from '../../../interfaces/ScanIqCustomerSetupInfo';
import { useScanIqCustomerListStore } from '../hooks/useScanIqCustomerListStore';

type FilterRowProps = {
  setupStatus: SetupStatusTab;
};

/*
  Rendered with key={setupStatus}: tab switch remounts the row, so the form
  re-inits from the active tab's stored filterData and the pending debounced
  auto-submit is cancelled on unmount.
*/
const FilterRow = observer(({ setupStatus }: FilterRowProps) => {
  const { filterMethods } = useScanIqCustomerListStore(setupStatus);
  const { isSuperAdmin } = loggedInUserDataStore;

  const { applyFilters, filterData, defaultFilterData } = filterMethods;

  const { control, reset, watch, handleSubmit } =
    useForm<ScanIqCustomerListFilterFormValues>({
      defaultValues: filterData,
    });

  useAutoSubmitForm(handleSubmit(applyFilters), watch, [
    'generalFilter.superSearch',
    'generalFilter.entityName',
  ]);

  const inputGeneralProps = {
    control,
    variant: 'outlined',
    size: 'small',
  } as const;

  const handleReset = () => {
    reset({ ...defaultFilterData });
  };

  return (
    <GridTableRow
      variant="filter"
      component="form"
      onSubmit={(event) => event.preventDefault()}
    >
      <LbInput
        {...inputGeneralProps}
        name="generalFilter.superSearch"
        placeholder="Name, email or phone number"
      />
      {isSuperAdmin && (
        <LbInput
          {...inputGeneralProps}
          name="generalFilter.entityName"
          placeholder="Entity"
        />
      )}
      <div />
      <div />
      <GridTableCell justify="end">
        <Button variant="outlined" size="small" type="reset" onClick={handleReset}>
          Clear All
        </Button>
      </GridTableCell>
    </GridTableRow>
  );
});

export { FilterRow };
